import Qs from 'qs'
import config from './config'
export default {
    url: '/user',
    method: 'get',
    baseURL: config.baseURL,
    transformResponse: [function (data) {
        return data
    }],
    timeout: 10000,
    responseType: 'json',

}



// WEBPACK FOOTER //
// ./src/fetch/configFile.js